import { render, staticRenderFns } from "./CloseQwDialog.vue?vue&type=template&id=bf8c4634&scoped=true"
import script from "./CloseQwDialog.vue?vue&type=script&lang=js"
export * from "./CloseQwDialog.vue?vue&type=script&lang=js"
import style0 from "./CloseQwDialog.vue?vue&type=style&index=0&id=bf8c4634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8c4634",
  null
  
)

export default component.exports